/* Phone menu: the search field at the top of the menu closes the menu and opens the header search. */
(function () {
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-piv-nav-search]');
    if (!b) return;
    ev.preventDefault();
    var menu = document.querySelector('header-drawer details[open] > summary.header__icon--menu');
    if (menu) menu.click(); // closes the menu
    var go = function () {
      var s = document.querySelector('details-modal.header__search summary');
      if (s) s.click();
    };
    setTimeout(go, menu ? 350 : 0);
  });
})();
